import React, { useEffect, useState } from "react";
import API from "../Services/Auth";
import { ToastContainer, toast } from "react-toastify";
import * as XLSX from "xlsx";

const Enquiry = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [customer, setCustomer] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const perPage = 10;
  const [search, setSearch] = useState("")

  useEffect(() => {
    bindEnquiryData(currentPage);
  }, [currentPage]);



  const handleFieldChange = (e, fieldName) => {
    const value = e.target.value;
    switch (fieldName) {
      case "search":
        setSearch(value);
        break;
      default:
        break;
    }
  }

  const bindEnquiryData = async (currentPage) => {
    try {
      const payload = {
         limit: perPage,
        pageNumber: currentPage,
        mobile: search,
      };
      const response = await API.customerEnquiry(payload);
      //console.log("data..", response?.data?.data)
      setCustomer(response?.data?.data || []);
      const totalPages = Math.ceil(response?.data?.total_count / perPage);
      setTotalCount(response?.data?.total_count);
      setTotalPages(totalPages);
    } catch (error) {
      handleError(error);
      if (!error.response) {
        toast.error("Network error! Please check your internet connection");
      } else if (error.response.status === 403) {
        window.location.replace("/Login")
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    }
  };


  const handleError = (error) => {
    console.error("Error:", error);
    if (error.response) {
      toast.error(error.response.data?.message || `Error: ${error.response.status}`);
    } else if (error.request) {
      toast.error("No response from server. Please try again later.");
    } else {
      toast.error("Something went wrong. Please try again.");
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleSearch = () => {
    setCurrentPage(1);
    bindEnquiryData(1);
  };


  const downloadCSV = async () => {
      try {
       const payload = {
        limit: null,
        pageNumber: currentPage,
        mobile: search,
        
      };
        const response = await API.customerEnquiry(payload);
        const result = response?.data?.data || [];
  
        if (!result.length) {
          toast.error("No data found!");
          return;
        }
        const worksheet = XLSX.utils.json_to_sheet(result);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Enquiry");
        XLSX.writeFile(workbook, "EnquiryReport.xlsx");
      } catch (error) {
        console.error("Error downloading Excel:", error);
      }
    };


  return (
    <div>
      <div className="col-lg-12 grid-margin stretch-card">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4 className="card-title mb-0">Total Enquiry  ({totalCount})</h4>
            {totalCount > 0 && (
              <button className="btn btn-primary btn-sm" onClick={downloadCSV}>
                <i className="fa fa-download"></i>
              </button>
            )}
          </div>

          <div className="card-body">
            <div className="row mb-3">
              <div className="col-md-4">
                <input type="text" className="form-control" placeholder="Search by Name,mobile,email"
                  value={search}
                  onChange={(e) => handleFieldChange(e, "search")}
                />
              </div>
              <div className="col-md-2">
                <button onClick={handleSearch} className="btn btn-success" type="button">Search</button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>SrNo</th>
                    <th>Customer Name</th>
                    <th>Mobile Number</th>
                    <th>Type</th>
                    <th>Message</th>
                    <th>Created Date</th>
                  </tr>
                </thead>
                <tbody>
                  {customer.map((item, index) => (
                    <tr key={item.id}>
                      <td>{(currentPage - 1) * perPage + index + 1}</td>
                      <td>{item.customer_name}</td>
                      <td>{item.mobile}</td>
                      <td>{item.type}</td>
                      <td>{item.message}</td>
                      {/* <td>{moment(item.createdAT).format("DD-MM-YYYY")}</td> */}
                      <td>{item.createdAt}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <nav aria-label="Page navigation example">
                <ul className="pagination justify-content-center mt-4">
                  <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}>
                      Previous
                    </button>
                  </li>
                  {Array.from({ length: totalPages }, (_, index) => (
                    <li
                      key={index + 1}
                      className={`page-item ${currentPage === index + 1 ? "active" : ""}`}>
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(index + 1)}>
                        {index + 1}
                      </button>
                    </li>
                  ))}
                  <li
                    className={`page-item ${currentPage === totalPages ? "disabled" : ""}`} >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}>
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Enquiry;
